import styled from "styled-components";
import { useEvent } from "../../contexts/EventContext";
import { EventSelect } from "../molecules/EventSelect";
import { PageSection } from "./PageSection";

const Bar = styled.div`
  display: grid;
  gap: 6px;
  margin-bottom: 12px;
`;

export function EventSelectorBar() {
  const { selectedEvent, setSelectedEvent } = useEvent();

  return (
    <Bar>
      <PageSection>イベント日程</PageSection>
      <EventSelect value={selectedEvent?.id ?? ""} onChange={setSelectedEvent} />
    </Bar>
  );
}
